export default "__VITE_ASSET__C436wr0U__"